module.exports = __webpack_public_path__ + "static/media/img13.26990003.jpeg";